var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var __target

module.exports = function description (model) {
elementOpen("div", "b7b013f8-c542-4980-b7ce-ac104e2d8968", hoisted1)
  elementOpen("div")
    elementOpen("label", "46095885-e0ad-4bca-8d8b-13317d7a77a3", hoisted2)
      elementOpen("input", "8bf8333f-7723-4d40-a23b-c2e973f531d5", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
}
